import { getThemeColor } from "@mcleod/core";
import { Panel } from "../components/panel/Panel";

/**
 * A SeparatorPanel is used to render a separator line without adding any height/width to the DOM.  The panel itself
 * is rendered no width/height (based on if the separator line is vertical/horizontal); the separator line is displayed
 * using pseudo-elements via a style tag.
 */
export class SeparatorPanel extends Panel {
    private styleElement: HTMLStyleElement;

    constructor(enclosingPanel: Panel, vertical: boolean = true, lengthInPercent: number = 90) {
        super({
            id: enclosingPanel.createInnerComponentId("separator"),
            margin: 0,
            padding: 0,
            rowBreak: !vertical,
            style: { position: "relative" },
        });
        if (vertical) {
            this.width = 0;
        } else {
            this.height = 0;
        }
        this.createStyleElement(vertical, lengthInPercent);
        this.addStyleElementToDOM(enclosingPanel);
    }

    private createStyleElement(vertical: boolean, lengthInPercent: number) {
        const offset = `${(100 - lengthInPercent)/2}%`;
        let variableCSS: string;
        if (vertical) {
            variableCSS = `
                top: ${offset};
                bottom: ${offset};
                left: -0.5px;  /* shifts border to the center of the gap */
            `;
        } else {
            variableCSS = `
                left: ${offset};
                right: ${offset};
                top: -0.5px;  /* shifts border to the center of the gap */
            `;
        }
        const styleElementCSS = `
            #${this.id}::before {
                content: '';
                position: absolute;
                border-left: 1px solid ${getThemeColor("strokeSecondary")};
                ${variableCSS}
            }
        `;
        this.styleElement = document.createElement('style');
        this.styleElement.setAttribute('data-id', this.id);
        this.styleElement.textContent = styleElementCSS;
    }

    private addStyleElementToDOM(enclosingPanel: Panel) {
        document.head.appendChild(this.styleElement);
        enclosingPanel.addUnmountListener(() => {
            if (document.head.contains(this.styleElement)) {
                document.head.removeChild(this.styleElement);
            }
        });
    }
}
